import {UInspectStat} from './uinspect-stat-dto.interface';

export interface UInspectStatData {
  date: Date;
  requested: UInspectStat[];
  opened: UInspectStat[];
  completed: UInspectStat[];
}
